export default __webpack_public_path__ + "static/media/drug.3d17748f.svg";